import React from "react";
import PagePdf from "../../components/common/PagePdf";

export const OfficeUM = () => {
  const fileUrl = process.env.REACT_APP_DOC_URL + "/public/user-manual-file?type=OFFICE";
  return <PagePdf fileUrl={fileUrl} />;
};
